import { Icon } from '@/components/Icon';
import { useIsMobile } from '@/hooks/useMediaQuery';
import styles from './BenefitCards.module.css';

import qrCodeScannerSvg from '../../assets/icons/qr-code-scanner.svg?raw';
import taskAltSvg from '../../assets/icons/task-alt.svg?raw';
import verifiedSvg from '../../assets/icons/verified.svg?raw';

const visaIcon = new URL('../../assets/icons/visa.svg', import.meta.url).href;
const mastercardIcon = new URL('../../assets/icons/mastercard.svg', import.meta.url).href;

type BenefitItem = {
  id: string;
  title: string;
  description: string;
} & (
  | { kind: 'icon'; svg: string }
  | { kind: 'payment' }
);

const benefits: BenefitItem[] = [
  {
    id: 'instant-confirmation',
    kind: 'icon',
    svg: taskAltSvg,
    title: 'Instant confirmation',
    description: 'Receive your QR code instantly after payment',
  },
  {
    id: 'fast-pickup',
    kind: 'icon',
    svg: qrCodeScannerSvg,
    title: 'Fast & easy pick up',
    description: 'Skip ticket office queues. Scan your QR code and collect your pass in minutes.',
  },
  {
    id: 'official-passes',
    kind: 'icon',
    svg: verifiedSvg,
    title: 'Official passes',
    description: 'Official ski passes issued by the resort at standard resort prices.',
  },
  {
    id: 'secure-payments',
    kind: 'payment',
    title: 'Secure payments',
    description: 'Encrypted checkout with trusted payment providers.',
  },
];

const BenefitIcon = ({ benefit, iconSize }: { benefit: BenefitItem; iconSize: number }) => {
  if (benefit.kind === 'payment') {
    return (
      <div className={styles.paymentIcons}>
        <img src={visaIcon} alt="Visa" className={styles.paymentIcon} />
        <img src={mastercardIcon} alt="Mastercard" className={styles.paymentIcon} />
      </div>
    );
  }

  return <Icon svg={benefit.svg} size={iconSize} color="var(--brand-main, #3284fa)" />;
};

export const BenefitCards = () => {
  const isMobile = useIsMobile();
  const iconSize = isMobile ? 32 : 24;

  return (
    <ul className={styles.grid}>
      {benefits.map((benefit) => (
        <li key={benefit.id} className={styles.card}>
          <div className={styles.iconWrap}>
            <BenefitIcon benefit={benefit} iconSize={iconSize} />
          </div>
          <div className={styles.textWrap}>
            <p className={styles.title}>{benefit.title}</p>
            <p className={styles.description}>{benefit.description}</p>
          </div>
        </li>
      ))}
    </ul>
  );
};
